import {whichTransition} from '../helpers/born.utils';
import {isMobile} from './../util';

export default class Megamenu{
    constructor(options){
        this.options = options || {};

        this.setProperties();

        this.menu = document.querySelector(this.options.menu);

        if (!this.menu) {
            console.warn('Could not find target element');
            return;
        }

        this._beforeItemSet    = this.options.beforeItemSet   || function(){};
        this._afterItemSet     = this.options.afterItemSet    || function(){};
        this._afterMenuSet     = this.options.afterMenuSet    || function(){};
        this._afterItemUnset   = this.options.afterItemUnset  || function(){};
        this._afterMenuUnset   = this.options.afterMenuUnset  || function(){};

        let triggers = this.menu.querySelectorAll(this.options.triggers);

        [].forEach.call(triggers, this.setupNavigation.bind(this));

        this.menu.addEventListener('mousemove', this.preventUndesiredHover.bind(this));

        /**
         * Determines if 'menu' should be closed when hovering out of it.
         * This can be set on a breakpoint basis, so that the 'menu' is not closed when tapping out.
         */
        if (this.options.unsetOnMouseleave) {
            this.menu.addEventListener('mouseleave', function(){
                this.unsetRelatives();
                this._afterItemUnset(triggers[0]);
            }.bind(this));
        }
    }

    /**
     * Calculates the speed at which the cursor is moving inside the 'menu'.
     * If the curve is too fast and skewed (meaning not vertical/horizontal), then the hover action will be ignored.
     * @param  {[Object]} evt ['mousemove' event object]
     */
    preventUndesiredHover(evt) {
        var newX = Math.abs(evt.clientX),
            newY = Math.abs(evt.clientY),
            diffX = Math.abs( (this._origX || 0) - newX ),
            diffY = Math.abs( (this._origY || 0) - newY );

        this._origX = newX;
        this._origY = newY;

        this.isMouseMoveFast = (diffX/diffY >= 0.5) ? true : false;
    }

    /**
     * Sets up the properties for the menu.
     * These can be set on a breakpoint basis.
     *
     * Properties::
        events: [String] string with events to listen to.
        menuActiveClass: [String] class to add to the 'menu' when the dropdowns are active
        itemActiveClass: [String] class to add to the 'item' when it is active
        unsetOnMouseleave: [Boolean] Determines if 'menu' should be closed when hovering out of it.
        cancelCloseSelf: [String | Boolean] Determines if item should close itself when actioning on it (i.e. clicks).
                                            Pass a class name to disallow the referenced element from closing.
        responsive: [Object] Sets breakpoints settings using this format:
                    responsive: [
                        {
                            breakpoint: <breakpoint>,
                            settings: {
                                property: value
                            }
                        }
                    ]
        
        allowClickThrough: [String | Boolean] On an anchor, specify a class which will enable clicks on if said anchor is also a 'menu' 'item'. Flag to false to disable link clicking.

     */
    setProperties(){
        this.options.events             = this.options.events || 'touchstart click mouseenter';
        this.options.menuActiveClass    = this.options.menuActiveClass || 'mega--active';
        this.options.itemActiveClass    = this.options.itemActiveClass || 'mega-item--active';
        this.options.unsetOnMouseleave  = this.options.hasOwnProperty('unsetOnMouseleave') ? this.options.unsetOnMouseleave : true;
        this.options.cancelCloseSelf    = this.options.cancelCloseSelf || undefined;

        //Loops through the responsive array
        //to replace default settings with breakpoint specific settings. 
        if(this.options.responsive.length > 0){
            this.options.responsive.sort(lowestBreakpoint);

            //Not using forEach cause can't kill the loop.
            for(var i = 0; i < this.options.responsive.length; i++){
                if(updateProperty.call(this, this.options.responsive[i])){
                    break;
                }
            }
        }

        /**
         * Updates properties with ones coming from a matching breakpoint.
         * @param  {[Object]} breakpointOpts literal with all breakpoint specific settings
         * @return {[Boolean]}
         */
        function updateProperty(breakpointOpts){
            if (document.body.offsetWidth <= breakpointOpts.breakpoint) {
                for(var key in breakpointOpts.settings){
                    this.options[key] = breakpointOpts.settings[key];
                }

                return true;
            }

            return false;
        }

        function lowestBreakpoint(a, b){
            return a.breakpoint > b.breakpoint;
        }
    }

    /**
     * Sets item/trigger specific settings and handlers
     * @param  {[Node]} trigger [Node to which the settings are going to be applied to]
     */
    setupNavigation(trigger){
        trigger.megamenu = {
            cancelCloseSelf: this.options.cancelCloseSelf ? trigger.classList.contains(this.options.cancelCloseSelf) : false
        };

        this.getParent(trigger);
        this.getTarget(trigger);

        if(trigger.megamenu.target){
            this.setupHandlers(trigger);
        }
    }

    /**
     * Gets the parent of the passed Node
     * @param  {[Node]} trigger [Node where we're getting the parent Node from]
     * @return {[Node]} [Parent of the passed element]
     */
    getParent(trigger){
        trigger.megamenu.parent = trigger.parentNode;

        return trigger.megamenu.parent;
    }

    /**
     * Gets the target of the passed Node (the first matching Node from the query)
     * @param  {[Node]} trigger [Node where we're getting the target Node from]
     * @return {[Node]} [Target of the passed element]
     */
    getTarget(trigger){
        trigger.megamenu.target = trigger.megamenu.parent.querySelector(this.options.target);

        return trigger.megamenu.target;
    }

    /**
     * Uses 'this.options.events' to set up handlers on per item/trigger basis.
     * @param  {[Node]} trigger [Node where we're setting handlers to]
     */
    setupHandlers(trigger){
        var scope = this;
        
        $(trigger).on(this.options.events, function(evt){
            var isTouch = evt.type.indexOf('touch') >= 0,
                isMobileFlag = isMobile(),
                isL1Image = evt.target.nodeName === 'IMG',
                anchorEle = isL1Image ? evt.target.parentElement.parentElement : evt.target,
                allowClickThroughEl = scope.options.allowClickThrough ? anchorEle.classList.contains(scope.options.allowClickThrough) : false,
                allowClickThroughDirectlyEl = scope.options.allowClickThroughDirectly ? anchorEle.classList.contains(scope.options.allowClickThroughDirectly) : false,
                disableDesktopFlyout = scope.options.flyOutDisabled ? anchorEle.classList.contains(scope.options.flyOutDisabled) : false;
            //Check if click was on an allowed element, if so allow link through.
            if ((isTouch || anchorEle.nodeName === 'A' && !allowClickThroughEl) && !allowClickThroughDirectlyEl) {
                evt.preventDefault();
            } else if(isTouch || (anchorEle.nodeName === 'A'  && !allowClickThroughEl)  && allowClickThroughDirectlyEl && !disableDesktopFlyout) {
                isL1Image && evt.preventDefault();
            }

            if (!allowClickThroughDirectlyEl && disableDesktopFlyout && !isMobileFlag && evt.type.indexOf('click') >= 0) {
                evt.preventDefault();
                window.location.href = $(evt.target).attr('href');
                return false;
            } else {

                if (evt.type.indexOf('mouseenter') >= 0) {
                    if (scope.isMouseMoveFast) {

                        scope.overstay = setTimeout(function () {
                            scope.toggleItemActive(this, evt.type, disableDesktopFlyout);
                        }.bind(this), 125);

                        return;
                    } else {
                        scope.toggleItemActive(this, evt.type, disableDesktopFlyout);
                    }
                } else if (!allowClickThroughDirectlyEl || (isL1Image && allowClickThroughDirectlyEl && !disableDesktopFlyout)) {
                    scope.toggleItemActive(this, evt.type, disableDesktopFlyout, !allowClickThroughDirectlyEl);
                }

                //Making sure further events are not fired after touchstart
                if (isTouch) {
                    evt.stopImmediatePropagation();
                }
            }
        });

        trigger.megamenu.parent.addEventListener('mouseleave', function(evt){
            clearInterval(scope.overstay);
        });

        trigger.megamenu.target.addEventListener('mouseleave', function(evt){
            scope.isMouseMoveFast = false;
        });

        trigger.megamenu.target.addEventListener('click', function(evt){
            scope.unsetItemActive(evt, trigger);
        });
    }

    /**
     * If the targeted item/trigger is active, and can be closed, removes the active status and fires _afterItemUnset.
     * Otherwise trigger is activated and the corresponding callbacks are fired. If disableDesktopFlyout option true flyout 
     * of desktop menu is disabled, mobileFlag used to determine mobile flyout of menu.
     * @param  {[Node]} trigger [description]
     * @param  {[String]} evtType [description]
     * @param  {[Boolean]} disableDesktopFlyout [description]
     * @param  {[Boolean]} mobileFlag [description]
     */
    toggleItemActive(trigger, evtType, disableDesktopFlyout, mobileFlag){

            if (trigger.classList.contains(this.options.itemActiveClass)) {
                if (evtType !== 'mouseenter' && !trigger.megamenu.cancelCloseSelf) {
                    this.unsetRelatives(trigger);
                    this._afterItemUnset(trigger);
                }
            } else {
                this._beforeItemSet(trigger);
                if(!mobileFlag){
                    this.unsetRelatives(trigger);
                }

                if (!disableDesktopFlyout || mobileFlag) { 
                    this.setItemActive(trigger); 
                }

                this._afterItemSet(trigger);
            }

    }
    
    /**
     * [setItemActive description]
        waitForAnimateEl: [String] Selector to use to determine when to set the 'active' state on the menu.
                                    Thist activation will wait until all transitions are complete on the targeted element.
     * @param {[Node]} trigger [item/trigger to set active]
     */
    setItemActive(trigger){

            trigger.classList.add(this.options.itemActiveClass); 
            trigger.megamenu.target.classList.add(this.options.itemActiveClass);
            trigger.megamenu.parent.classList.add(this.options.itemActiveClass);

            trigger.megamenu.target.scrollTop = 0;
            if($(window).width() > 767) {
                let fixitHeader = $('.header__main.fixit--active');
                let heightReduction = fixitHeader.length ? fixitHeader.outerHeight() : $('.header').outerHeight();
                let setHeight =  `calc(100vh - ${heightReduction}px)`;
                $('.header__catmenu__sub.level-2').css('max-height', setHeight);
            } else {
                $('.header__secondary__content').addClass('cancel-scroll');
            }

        if( !this.menu.isActive ) {
            if( this.options.waitForAnimateEl ) {
                let $activeWaitEl = $(this.options.waitForAnimateEl + '.' + this.options.itemActiveClass);

                $activeWaitEl.on(whichTransition() + '.megaActive', function(){
                    this.setMenuActive();

                    $activeWaitEl.off('.megaActive');
                }.bind(this));
            } else {
                this.setMenuActive();
            }
        } else if( this._menuUnsetTimeout ) {
            clearTimeout(this._menuUnsetTimeout);
        }
    }

    /**
     * [Unsets the active state on the trigger]
     * @param  {[type]} evt     [description]
     * @param  {[type]} trigger [description]
     */
    unsetItemActive(evt, trigger){
        if(evt.target.getAttribute('data-menu-close') && $(evt.target).closest(this.options.target)[0] === trigger.megamenu.target){
            this.unsetRelatives(trigger);
            this._afterItemUnset(trigger);
        }
    }

    /**
     * Sets 'this.menu' to active only if it has any active items, then '_afterMenuSet' is fired
     */
    setMenuActive() {
        if(this.menu.querySelector('.' + this.options.itemActiveClass)){
            this.menu.isActive = true;
            this.menu.classList.add(this.options.menuActiveClass);
            this._afterMenuSet(this.menu);
        }
    }

    /**
     * Unsets all of the [trigger] relatives, then '_afterMenuUnset' is fire
     */
    unsetRelatives(trigger){
         var commonContainer = null;
        if(isMobile()){
            commonContainer = trigger ? trigger.megamenu.target.parentNode : this.menu;
        }
        else{
            commonContainer = trigger ? trigger.megamenu.parent.parentNode : this.menu;
        }
        
        var activeElements = commonContainer.querySelectorAll('.' + this.options.itemActiveClass);

        Array.prototype.forEach.call(activeElements, function(el){
            el.classList.remove(this.options.itemActiveClass);
        }.bind(this));

        //If there are no more active items, unset the nav.
        //Sets a very short timer to determine if another item was set
        //before unsetting the whole navigation. 
        if( !this.menu.querySelector('.' + this.options.itemActiveClass) ) {
            this._menuUnsetTimeout = setTimeout(function(){
                this.menu.isActive = false;
                this.menu.classList.remove(this.options.menuActiveClass);
                this._afterMenuUnset(this.menu);
            }.bind(this), 10);
        }
        $('.header__catmenu__sub.level-2').css('max-height', '');
        $('.header__secondary__content').removeClass('cancel-scroll');
    }
}


// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/modules/module.megamenu.js